"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionOrBackup = exports.groupSubscriptionsByParent = exports.buildDiscontinuedReplacedProductData = exports.buildBackupProductData = void 0;
var helpers_1 = require("../utils/helpers");
var prices_1 = require("../utils/prices");
var groupBy_1 = __importDefault(require("lodash/groupBy"));
function buildBackupProductData(params) {
    var _a, _b, _c, _d;
    var backupProduct = params.backupProduct, backupQuantity = params.backupQuantity, backupVariantId = params.backupVariantId, interval = params.interval;
    if (!backupProduct || !backupVariantId || !backupQuantity) {
        return undefined;
    }
    var expandedBackupProduct = backupProduct.obj;
    var current = expandedBackupProduct === null || expandedBackupProduct === void 0 ? void 0 : expandedBackupProduct.masterData.current;
    var variant = __spreadArray([current === null || current === void 0 ? void 0 : current.masterVariant], ((_a = current === null || current === void 0 ? void 0 : current.variants) !== null && _a !== void 0 ? _a : []), true).find(function (v) { return (v === null || v === void 0 ? void 0 : v.id) === backupVariantId; });
    if (!current || !variant) {
        throw new Error("Backup variant with ID ".concat(backupVariantId, " not found for product ").concat(backupProduct.id));
    }
    var backupVariant = __assign(__assign({}, variant), (0, helpers_1.pivotAttributeValues)(variant.attributes).variant);
    var backupRawPrice = (_c = (_b = variant.prices) === null || _b === void 0 ? void 0 : _b.find(function (p) { return p.value.currencyCode === 'USD'; })) === null || _c === void 0 ? void 0 : _c.value;
    if (!backupVariant.autoDeliveryEligible ||
        !backupVariant.active ||
        backupVariant.backordered ||
        !expandedBackupProduct.masterData.published ||
        !backupRawPrice) {
        return undefined;
    }
    var backupPrices = (0, prices_1.computePrices)({
        interval: interval,
        quantity: backupQuantity,
        variant: backupVariant,
    });
    return {
        currentPiecePrice: backupPrices.currentPiecePrice,
        discountedExtendedPrice: backupPrices.discountedExtendedPrice,
        discountedPiecePrice: backupPrices.discountedPiecePrice,
        extendedPrice: backupPrices.extendedPrice,
        images: current.masterVariant.images,
        name: current.name,
        onSale: backupPrices.onSale,
        piecePrice: backupPrices.piecePrice,
        productPath: (0, helpers_1.mountProductPath)(variant.attributes, current.categories),
        quantity: backupQuantity,
        sku: (_d = backupVariant.sku) !== null && _d !== void 0 ? _d : '',
        variant: backupVariant,
    };
}
exports.buildBackupProductData = buildBackupProductData;
function buildDiscontinuedReplacedProductData(params) {
    var _a, _b;
    var discontinuedReplacedProduct = params.discontinuedReplacedProduct, discontinuedReplacedVariantId = params.discontinuedReplacedVariantId, discontinuedReplacedQuantity = params.discontinuedReplacedQuantity;
    if (!discontinuedReplacedProduct || !discontinuedReplacedVariantId) {
        return undefined;
    }
    var expandedProduct = discontinuedReplacedProduct.obj;
    if (!expandedProduct) {
        throw new Error('discontinuedReplacedProduct not loaded');
    }
    var current = expandedProduct === null || expandedProduct === void 0 ? void 0 : expandedProduct.masterData.current;
    var variant = __spreadArray([current === null || current === void 0 ? void 0 : current.masterVariant], ((_a = current === null || current === void 0 ? void 0 : current.variants) !== null && _a !== void 0 ? _a : []), true).find(function (v) { return (v === null || v === void 0 ? void 0 : v.id) === discontinuedReplacedVariantId; });
    if (!current || !variant) {
        throw new Error("Discontinued Replaced variant with ID ".concat(discontinuedReplacedVariantId, " not found for product ").concat(discontinuedReplacedProduct.id));
    }
    var replacedVariant = __assign(__assign({}, variant), (0, helpers_1.pivotAttributeValues)(variant.attributes).variant);
    return {
        productName: current.name.en,
        variantName: (_b = replacedVariant.variantName) === null || _b === void 0 ? void 0 : _b.en,
        quantity: discontinuedReplacedQuantity,
        weight: replacedVariant.weight,
    };
}
exports.buildDiscontinuedReplacedProductData = buildDiscontinuedReplacedProductData;
function groupSubscriptionsByParent(subscriptions) {
    var _a = (0, groupBy_1.default)(subscriptions, function (s) { var _a; return (_a = s.parentExternalId) !== null && _a !== void 0 ? _a : 'parents'; }), _b = _a.parents, parents = _b === void 0 ? [] : _b, childrenByParentId = __rest(_a, ["parents"]);
    return parents.map(function (parent) {
        if (parent.externalId) {
            var children = childrenByParentId[parent.externalId];
            if (children) {
                parent.setChildren(children);
                parent.calculatePricesWithChildren();
            }
        }
        return parent;
    });
}
exports.groupSubscriptionsByParent = groupSubscriptionsByParent;
function subscriptionOrBackup(subscription) {
    var shouldUseBackup = subscription.displayBackupProduct &&
        (subscription.unavailableReason || subscription.preferBackup);
    return shouldUseBackup ? subscription.displayBackupProduct : subscription;
}
exports.subscriptionOrBackup = subscriptionOrBackup;
//# sourceMappingURL=subscription.js.map